import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import type { UseProductionOverviewDetailResult } from '@hooks/dashboard/useProductionOverviewDetail'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import OverviewMetricSectionCardContent from '../OverviewMetricSectionCardContent.component'

const DENTIST_HYGIENIST_LEGEND = [
  { label: 'Dentist', color: 'var(--blue-400)' },
  { label: 'Hygienist', color: 'var(--orange-300)' },
] as const

function vsHighlight(actual: string, goal: string): React.ReactElement {
  return (
    <>
      {actual} <span className="dashboard-metric-value-vs">vs</span>{' '}
      <span className="dashboard-metric-value-over">{goal}</span>
    </>
  )
}

type ProductionOverviewCardProps = {
  titleHref: string
  production: UseProductionOverviewDetailResult
  title?: string
  className?: string
}

function ProductionOverviewCardImpl({
  titleHref,
  production,
  title = 'Production',
  className = 'dashboard-acceptance-card',
}: ProductionOverviewCardProps): React.ReactElement {
  const { topMetrics, highlight, chart, loading, hasData, hasPayload } =
    production
  const isEmpty = shouldShowDashboardSectionEmpty(loading, hasData)
  const pending = isDashboardSectionPending(loading, hasPayload)

  return (
    <DashboardSectionCard
      title={title}
      titleHref={titleHref}
      className={className}
      loading={pending}
      skeleton={{ metrics: 4, block: 'chart' }}
      isEmpty={isEmpty}
      disableTitleLink={isEmpty}
    >
      <OverviewMetricSectionCardContent
        topMetrics={topMetrics}
        highlight={{
          leftLabel: highlight.leftLabel,
          value: vsHighlight(highlight.grossActual, highlight.grossGoal),
        }}
        chart={chart}
        legend={[...DENTIST_HYGIENIST_LEGEND]}
      />
    </DashboardSectionCard>
  )
}

export const ProductionOverviewCard = React.memo(ProductionOverviewCardImpl)
